export const getStarted = {
  'get-started': {
    bgColor: 'white',
    boxShadow: '1px 2px 6px rgba(0, 0, 0, 0.075)',
    borderRadius: '0px 0px 12px 12px',
    overflow: 'hidden',
  },
};
